module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_serpentine_owl-a373ae36365da66709e17a89328779a4.jpg";